import { ref, readonly } from 'vue';

const _isVisibleModalAccountDelete = ref(false);

export const useModalAccountDelete = () => {
  const isVisibleModalAccountDelete = readonly(_isVisibleModalAccountDelete);

  const openModalAccountDelete = () => {
    _isVisibleModalAccountDelete.value = true;
  };

  const closeModalAccountDelete = () => {
    _isVisibleModalAccountDelete.value = false;
  };

  return {
    isVisibleModalAccountDelete,
    openModalAccountDelete,
    closeModalAccountDelete,
  };
};
